import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { UtilService } from 'src/app/shared';
import { EventListHtDto } from '../../shared/event-list-ht.dto';
import { EventSubmissionService } from '../../shared/event-submission.service';
import { EventTypeService } from '../../shared/event-type/event-type.service';

@Component({
  selector: 'wl-submission-review-modal',
  templateUrl: './submission-review-modal.component.html',
  styleUrls: ['./submission-review-modal.component.less'],
    standalone: false
})
export class SubmissionReviewModalComponent implements OnInit {
  eventSubmission = { Descr: '' } as EventListHtDto;
  public isReviewing: boolean = false;
  isSaving: boolean = false;
  loadingEventSubmission: boolean = false;
  eventTypes: SelectItem[] = [];
  showHTMLEditor: boolean = false;

  constructor(private _eventTypeService: EventTypeService, private _eventSubmissionService: EventSubmissionService) {
    this._eventTypeService.getEventTypes().then((result) => {
      result.forEach((item) => {
        this.eventTypes.push({ label: item, value: item });
      });
    });
  }

  ngOnInit(): void {}

  open(eventSubmission: EventListHtDto) {
    this.showHTMLEditor = true;
    this.isReviewing = true;
    this.loadingEventSubmission = true;

    this._eventSubmissionService.getEventSubmission(eventSubmission.EventID).then(es => {
      this.eventSubmission = es;
    }).catch(() => {
      this.eventSubmission = eventSubmission;
    }).finally(() => {
      this.loadingEventSubmission = false;
    })

    if (this.eventSubmission.Descr == null) {
      this.eventSubmission.Descr = "";
    }
  }

  reject(eventSubmission: EventListHtDto): void {
    eventSubmission.Rejected = true;
    eventSubmission.Approved = false;

    this._eventSubmissionService.updateEventSubmission(eventSubmission).then(() => {
      this.isReviewing = false;
    });
  }

  close(): void {
    this.eventSubmission = {} as EventListHtDto;
    this.isSaving = false;
    this.isReviewing = false;
    this.loadingEventSubmission = false;
  }
  save(eventSubmission: EventListHtDto): void {
    this.isSaving = true;

    eventSubmission.Approved = true;
    eventSubmission.Rejected = false;
    this._eventSubmissionService.updateEventSubmission(eventSubmission).then(() => {
      this.close();
    });
  }
}
